// llmNode.js

import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const LLMNode = ({ id, data }) => {
  const handles = [
    { id: 'system', type: 'target', position: Position.Left, top: 33 },
    { id: 'prompt', type: 'target', position: Position.Left, top: 67 },
    { id: 'response', type: 'source', position: Position.Right }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      title="LLM"
      description="Language Model Node"
      handleConfig={handles}
      width={200}
      height={160}
    />
  );
}
